<template>
  <div>
    <b-row class="justify-content-md-center text-center">
      <h3>장례식장 위치를 알려주세요.</h3>
    </b-row>

    <b-row class="justify-content-md-center text-center">
      <b-form-select v-model="position" :options="positionValues" size="sm" class="mt-3"></b-form-select>
      <div class="mt-3">디버깅용: <strong>{{ position }}</strong></div>
    </b-row>

    <br/>

    <template v-if="position != null">
      <b-row class="justify-content-md-center text-center">
        <b-form-input v-model="name" placeholder="장례식장 이름을 알려주세요."></b-form-input>
      </b-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BugoInput',
  data () {
    return {
      position: null,
      positionValues: [
        { value: null, text: '지역이 어디인가요?' },
        { value: 'seoul', text: '서울특별시' },
        { value: 'busan', text: '부산광역시' },
        { value: 'dague', text: '대구광역시' },
      ],
      name: null,
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
